module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainlayout"
  }, [_c('div', {
    staticClass: "top-panel"
  }, [_c('div', {
    staticClass: "top-panel-logo-panel",
    class: {
      'top-panel-logo-panel-grey': _vm.mainMenuType.value != _vm.mainMenuType.FULLWIDTH
    }
  }, [_c('div', {
    staticClass: "top-panel-logo-panel-icon"
  }, [_c('Icon', {
    attrs: {
      "type": "cube"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "top-panel-logo-panel-text"
  }, [_c('div', [_vm._v(_vm._s(_vm.appSettings.appName))]), _vm._v(" "), _c('div', {
    staticClass: "top-panel-logo-panel-text-ver"
  }, [_vm._v(_vm._s(_vm.appSettings.appVer))])]), _vm._v(" "), _c('Button', {
    staticClass: "top-panel-logo-panel-button",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.mainMenuOnClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "navicon"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('Button', {
    staticClass: "top-panel-cmsreinit-button",
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.cmsReinitOnClick
    }
  }, [_vm._v("Обновить кэш")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "18px",
      "padding-left": "10px",
      "float": "left"
    }
  }, [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.time, 'timeWithoutSeconds')) + "   |   \n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "18px",
      "float": "left"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.appSettings.server.host.indexOf('localhost') == -1 ? _vm.appSettings.company.name : _vm.appSettings.company.name + ' DEV ' + _vm.appSettings.server.host) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "8px",
      "right": "20px"
    }
  }, [(_vm.activeUser) ? _c('font', {
    attrs: {
      "size": "3px"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.activeUser.Name) + "\n         "), _c('Button', {
    attrs: {
      "size": "large",
      "type": "text"
    },
    on: {
      "click": _vm.logoutOnClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "power",
      "size": "15"
    }
  }), _vm._v(" Выход\n         ")], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mainmenu-panel",
    class: {
      'mainmenu-panel-narrow': _vm.mainMenuType.value == _vm.mainMenuType.NARROW, 'mainmenu-panel-collapsed': _vm.mainMenuType.value == _vm.mainMenuType.COLLAPSED
    }
  }, [_c('div', {
    staticClass: "mainmenu-panel-hide-scroll-inner",
    class: {
      'mainmenu-panel-hide-scroll-inner-narrow': _vm.mainMenuType.value == _vm.mainMenuType.NARROW
    }
  }, [_c('MainMenu', {
    staticClass: "mainmenu mainmenu-style",
    on: {
      "returninstance": _vm.setMainMenuInstance
    }
  }), _vm._v(" "), (_vm.mainMenuType.value == _vm.mainMenuType.FULLWIDTH) ? _c('div', {
    staticClass: "mainmenu-footer"
  }, [_c('div', {
    staticClass: "mainmenu-footer-hr"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      'content-with-narrow-mainmenu': _vm.mainMenuType.value == _vm.mainMenuType.NARROW, 'content-with-fullwidth-mainmenu': _vm.mainMenuType.value == _vm.mainMenuType.FULLWIDTH
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _c('br'), _vm._v("© ROKKETS, 2021\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3d3d93a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainLayout.vue
// module id = 384
// module chunks = 0